import { Link, useLocation } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";

export default function NotFound() {
  const location = useLocation();

  return (
    <SiteLayout
      title="页面未找到 - 91动漫"
      description="你访问的页面不存在，可以返回 91动漫首页继续浏览动漫资讯与作品推荐。"
      keywords="91动漫,页面未找到"
    >
      <section className="w-full px-4 md:px-8 py-20 md:py-28 bg-background-50">
        <div className="flex flex-col items-center text-center">
          <span className="font-heading font-extrabold text-primary-500/25 text-[96px] md:text-[160px] leading-none select-none">
            404
          </span>
          <h1 className="mt-2 font-heading font-bold text-foreground-950 text-xl md:text-2xl">页面走丢了</h1>
          <p className="mt-2 text-xs md:text-sm text-foreground-500 font-label break-all">{location.pathname}</p>
          <p className="mt-3 text-sm text-foreground-600 max-w-md leading-relaxed">
            这个链接可能已经失效。回到首页看看最新的动漫资讯，或直接去作品库逛一逛吧。
          </p>
          <div className="mt-6 flex flex-wrap justify-center gap-3">
            <Link
              to="/"
              className="inline-flex items-center gap-2 h-10 px-5 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium whitespace-nowrap transition-colors duration-200 cursor-pointer"
            >
              <i className="ri-home-4-line" />
              返回首页
            </Link>
            <Link
              to="/anime"
              className="inline-flex items-center gap-2 h-10 px-5 rounded-md border border-background-300 text-foreground-800 hover:border-primary-400 hover:text-primary-600 text-sm font-medium whitespace-nowrap transition-colors duration-200 cursor-pointer"
            >
              浏览作品
            </Link>
          </div>
        </div>
      </section>
    </SiteLayout>
  );
}